import jp2 from './turkey-bowl.jp2';
import png from './turkey-bowl.png';
import webp from './turkey-bowl.webp';

export const turkeyBowls = [webp, jp2, png];
